import { Tooltip } from "antd";
import classNames from "classnames";
import { FormFieldProps } from "components/shared/inputs/formField";
import SRadio, { RadioType } from "components/shared/inputs/radio";
import SOptionBar from "components/shared/optionBar";
import { Control, useController } from "react-hook-form";
import { Text } from "components/shared/text";

interface OptionBarProps {
  name: string;
  control: Control<any>;
  label: string;
  dataLength?: string;
  options: Array<{
    value: string;
    text: string;
  }>;
}

export const OptionBar: React.FC<OptionBarProps & FormFieldProps> = ({
  name,
  control,
  options,
  label,
  helpText,
  info,
  dataLength,
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({ control, name });

  return (
    <group
      data-name="toggle"
      data-length={dataLength || "400"}
      data-direction="column"
      className={classNames({ validationError: error })}
    >
      <group
        data-name="toggle_cont"
        data-space="10"
        data-space-left="15"
        data-min-height="30"
        data-border=""
        data-align="center"
        data-gap="10"
        data-radius="special"
        data-color="grey-color-dark"
        data-wrap="no"
      >
        <group data-width="auto" data-fit="1" data-contain="">
          <div className="field">
            <label className="form_fields">
              <div className="data_label">
                <text
                  data-color="grey-color-mid"
                  data-text-size="15"
                  data-contain=""
                  data-ellipsis=""
                  data-clamp="2"
                >
                  {label}
                </text>
                {helpText && (
                  <Tooltip
                    arrow={false}
                    color="var(--accent-dark)"
                    space={false}
                    title={
                      <group data-direction="column" data-gap="10" data-space="5">
                        <Text data-weight="700" data-wrap="wrap">
                          {helpText}
                        </Text>
                      </group>
                    }
                  >
                    <div
                      data-position="right"
                      data-type="group"
                      data-width="auto"
                      data-space="5"
                      data-interactive=""
                      data-radius="30"
                      data-color="grey-color-mid"
                    >
                      <icon data-icon-size="small">help</icon>
                    </div>
                  </Tooltip>
                )}
              </div>
            </label>
          </div>
        </group>
        <SOptionBar fixed animate>
          {options.map((o) => (
            <SRadio
              key={o.value}
              control={control}
              radioType={RadioType.Button}
              radioValue={o.value}
              name={field.name}
              label={o.text}
              onChange={field.onChange}
              checked={o.value === field.value}
              // {...(o.value === field.value ? { checked: true } : {})}
            />
          ))}
        </SOptionBar>
      </group>
      {error && (
        <errormessage>
          <text
            data-wrap="wrap"
            className="errorMessage"
            data-contain=""
            data-ellipsis=""
          >
            {error.message}
          </text>
        </errormessage>
      )}
      {info && (
        <infomessage>
          <text
            data-wrap="wrap"
            className="errorMessage"
            data-contain=""
            data-ellipsis=""
          >
            {info}
          </text>
        </infomessage>
      )}
    </group>
  );
};
